import { useState } from 'react';
import { createContainer } from 'unstated-next';

// 总数据
const useStore = (initialState = {}) => {
    const [states, setStates] = useState(initialState);

    const changeStates = newStates => {
        setStates(states => Object.assign({}, states, newStates));
    };

    return { states, changeStates };
};

export const Store = createContainer(useStore);

// 列表相关的状态
const useListStore = (
    initialState = {
        account: {}, // 自媒体账号
        brandHeight: '', // 端外分享栏高度
        statusBarHeight: '', // 状态栏高度
        videoHeight: '', // 视频高度
        briefHeight: 0, // 简介栏高度
        videoAndStatusBarHeight: '', // 视频加状态栏高度
        currentVideo: {}, // 当前视频信息
        dramaSeries: [], // 剧集
        positive: [], // 正片（选集）
        related: [], // 相关推荐
        crowd: [], // 合辑id
        gagsList: [], // 片段花絮列表
        gags: [], // 片段花絮
        recommond: [], // 更多推荐
        page: 1, // 页码
        isNightMode: false, // 日夜间
    },
) => {
    const [listStates, setListStates] = useState(initialState);

    const changeListStates = newListStates => {
        setListStates(prevStates => {
            return Object.assign({}, prevStates, newListStates);
        });
    };

    return { listStates, changeListStates };
};

export const ListStore = createContainer(useListStore);
